import React, { Component } from 'react';
import { Tabs } from 'antd';

import BillingIssues from './BillingIssues';
import PanelAcknowledgement from '../PanelAcknowledgement/PanelAcknowledgement';

// Action Items: everything the practice needs to act on, one tab per kind.
//   Billing                 open Telcor billing issues for this client
//   Panel Acknowledgements  custom panels waiting for a physician signature
// Each tab reports its open count back for the label.

class ActionItems extends Component {
  state = { billingCount: null, panelCount: null };

  render() {
    const { client } = this.props;
    const { billingCount, panelCount } = this.state;
    const withCount = (text, n) => (n ? `${text} (${n})` : text);
    return (
      <Tabs
        size="small"
        items={[
          {
            key: 'billing',
            label: withCount('Billing', billingCount),
            children: <BillingIssues client={client} onCount={(n) => this.setState({ billingCount: n })} />,
          },
          {
            key: 'panels',
            label: withCount('Panel Acknowledgements', panelCount),
            children: <PanelAcknowledgement client={client} onCount={(n) => this.setState({ panelCount: n })} />,
          },
        ]}
      />
    );
  }
}

export default ActionItems;
